import { HttpClient } from "@angular/common/http";
import { Component, Inject } from "@angular/core";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { AbstractControl, UntypedFormControl } from "@angular/forms";
import { ThemePalette } from "@angular/material/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { AngularEditorConfig } from '@kolkov/angular-editor';

@Component({
    selector: 'dialog-publish-dialog',
    templateUrl: 'dialogpublish.html',
})
export class PublishDialog {
    public disabled = false;
    public color: ThemePalette = 'primary';
    public touchUi = false;
    public disclaimer = "";
    window: any;

    colorCtr: AbstractControl = new UntypedFormControl(null);

    color1: any;
    publishedprojects: any;
    project: any; newproject: any;
    sheetData: any; // Add property to hold spreadsheet data
    replaceid = null;
    step = 1;
    SERVER = "https://us-central1-xbuild3d.cloudfunctions.net";  //http://localhost:5001/xbuild3d/us-central1";

    isGeneratingDescription = false; // Flag for loading state
    isGeneratingKeywords = false; // Flag for loading state

    editorConfig: AngularEditorConfig = {
        editable: true,
        spellcheck: true,
        height: '230px',
        minHeight: '0',
        maxHeight: 'auto',
        width: 'auto',
        minWidth: '0',
        translate: 'yes',
        enableToolbar: true,
        showToolbar: true,
        placeholder: 'Enter text here...',
        defaultParagraphSeparator: '',
        defaultFontName: '',
        defaultFontSize: '',
        fonts: [
            { class: 'arial', name: 'Arial' },
            { class: 'times-new-roman', name: 'Times New Roman' },
            { class: 'calibri', name: 'Calibri' },
            { class: 'comic-sans-ms', name: 'Comic Sans MS' }
        ],
        customClasses: [
            {
                name: 'quote',
                class: 'quote',
            },
            {
                name: 'redText',
                class: 'redText'
            },
            {
                name: 'titleText',
                class: 'titleText',
                tag: 'h1',
            },
        ],
        uploadUrl: 'v1/image',
        //     upload: (file: File) => { ... }
        uploadWithCredentials: false,
        sanitize: true,
        toolbarPosition: 'top',
        toolbarHiddenButtons: [
            [
                'undo',
                'redo',
                //         'bold',
                //         'italic',
                //         'underline',
                'strikeThrough',
                'subscript',
                'superscript',
                //       'justifyLeft',
                //       'justifyCenter',
                //       'justifyRight',
                //       'justifyFull',
                'indent',
                'outdent',
                //       'insertUnorderedList',
                //       'insertOrderedList',
                //       'heading',
                'fontName'
            ],
            [
                'fontSize',
                'textColor',
                'backgroundColor',
                'customClasses',
                //           'link',
                //         'unlink',
                'insertImage',
                'insertVideo',
                //       'insertHorizontalRule',
                'removeFormat',
                //         'toggleEditorMode'
            ]
        ]
    };
    editorConfig2: AngularEditorConfig = {

    };

    constructor(public http: HttpClient, public dialogRef: MatDialogRef<PublishDialog>, @Inject(MAT_DIALOG_DATA) public data: any, public afs: AngularFirestore) {
        this.color1 = "#ff0000";
        this.window = window;
        console.log("PublishDialog", this.data);
        this.sheetData = this.data.dataset; // Retrieve dataset
        this.editorConfig2 = JSON.parse(JSON.stringify(this.editorConfig));
        this.editorConfig2.height = '130px';

        this.project = this.data.project;
        if (!this.project.initialcamera)
            this.project.initialcamera = this.project.cameras[0];

        if (!this.project.description) {
            this.generateDescription();
        }
        if (!this.project.keywords) {
            this.generateKeywords();
        }

        this.afs.collection("projectspublic/", ref => ref.orderBy('date', 'desc').where('userid', "==", this.data.userid)).valueChanges({ idField: 'id' }).subscribe(x => {
            if (x) {
                console.log('publishedprojects', x);
                this.publishedprojects = x;
            }
        });

    }

    // Method to call the new endpoint
    async generateDescription() {
        // Use sheetData for the check
        if (!this.sheetData || !this.sheetData[0]) {
            console.error("Cannot generate description: Spreadsheet data (sheetData) or first row is missing.");
            // Optionally show a user-facing error message here
            return;
        }

        this.isGeneratingDescription = true;
        try {
            // Extract headers from sheetData
            const inputHeaders = this.sheetData; //.slice(0, 12); // A=0, B=1, ..., L=11

            console.log("Sending sheetdata to generate description:", inputHeaders);

            const result: any = await this.http.post(this.SERVER + "/generateTableDescription",
                { inputHeaders: inputHeaders }
            ).toPromise();

            if (result && result.success && result.description) {
                console.log("Generated description:", result.description);
                // Update the project description field
                this.project.description = result.description;
                // Optionally, show a success message
            } else {
                console.error("Failed to generate description:", result);
                // Optionally, show a user-facing error message
            }
        } catch (error) {
            console.error('Error generating description:', error);
            // Optionally, show a user-facing error message
        } finally {
            this.isGeneratingDescription = false;
        }
    }

    // Method to call the new keywords endpoint
    async generateKeywords() {
        // Use sheetData for the check
        if (!this.sheetData || !this.sheetData[0]) {
            console.error("Cannot generate keywords: Spreadsheet data (sheetData) or first row is missing.");
            return;
        }

        this.isGeneratingKeywords = true;
        try {
            // Extract headers from sheetData
            const inputHeaders = this.sheetData; //.slice(0, 12); // A=0, B=1, ..., L=11
            console.log("Sending sheetdata to generate keywords:", inputHeaders);

            const result: any = await this.http.post(this.SERVER + "/generateKeywordsFromInputs",
                { inputHeaders: inputHeaders }
            ).toPromise();

            if (result && result.success && result.keywords) {
                console.log("Generated keywords:", result.keywords);
                // Update the project keywords field, replacing comma-separated with hyphenated
                this.project.keywords = result.keywords.replace(/,/g, '-');
            } else {
                console.error("Failed to generate keywords:", result);
            }
        } catch (error) {
            console.error('Error generating keywords:', error);
        } finally {
            this.isGeneratingKeywords = false;
        }
    }

    private generateShortId(length: number = 4): string {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        const timestamp = Date.now().toString(36).slice(-4);
        const randomPart = Array(length - 4).fill(0)
            .map(() => chars.charAt(Math.floor(Math.random() * chars.length)))
            .join('');
        return timestamp + randomPart;
    }

    async publish() {
        this.step = 2;
        this.newproject = JSON.parse(JSON.stringify(this.project));
        const originalUserProjectId = this.project.id; // ID of the source user project
        const publisherUserId = this.data.userid;

        // this.newproject.publisdate = new Date().getTime(); // Typo in original, publishtime is used
        this.newproject.userid = publisherUserId;

        try {
            let publicProjectId;
            if (!this.replaceid) {
                publicProjectId = this.generateShortId();
                this.newproject.id = publicProjectId;
                console.log('Generated new short ID for public project:', publicProjectId);
            } else {
                publicProjectId = this.replaceid;
                this.newproject.id = publicProjectId;
            }

            this.newproject.publishtime = new Date().getTime();
            await this.afs.collection('projectspublic').doc(publicProjectId).set(this.newproject);
            console.log(`Published project main document to projectspublic/${publicProjectId}`);

            // Copy tdstyles from the original user project to the public project
            const sourceStylesPath = `/projects/userprojects/${publisherUserId}/${originalUserProjectId}/tdstyles`;
            const destinationStylesPathBase = `/projectspublic/${publicProjectId}/tdstyles`;

            try {
                const tdStylesSnapshot = await this.afs.collection(sourceStylesPath).get().toPromise();
                if (tdStylesSnapshot.empty) {
                    console.log(`No tdstyles found at ${sourceStylesPath} for original project ${originalUserProjectId}. Nothing to copy for public project.`);
                } else {
                    const batch = this.afs.firestore.batch();
                    tdStylesSnapshot.docs.forEach(doc => {
                        const styleData = doc.data();
                        const newPublicStyleDocRef = this.afs.doc(`${destinationStylesPathBase}/${doc.id}`).ref;
                        batch.set(newPublicStyleDocRef, styleData);
                    });
                    await batch.commit();
                    console.log(`Successfully copied ${tdStylesSnapshot.size} style documents from ${sourceStylesPath} to ${destinationStylesPathBase}`);
                }
            } catch (styleError) {
                console.error(`Error copying tdstyles from ${sourceStylesPath} to ${destinationStylesPathBase}:`, styleError);
                // Optionally, handle this error, e.g., by informing the user or stopping the publish process
            }

            // The rest of the configmodel logic and /copySheets call
            // Consider if /copySheets also needs to be aware of the target being public, e.g. by passing a flag
            var result = await ((this.http.post(this.SERVER + "/copySheets",
                {
                    customerid: publisherUserId,
                    projectid: originalUserProjectId,
                    newprojectid: publicProjectId,
                    sheetscount: this.project.sheets.length,
                    isPublicTarget: true // Example flag if backend needs to differentiate
                })).toPromise());
            this.step = 3;
            console.log('copySheets result for publishing:', result);
        } catch (error) {
            console.error('Error publishing project:', error);
            // Optionally, provide feedback to the user or rethrow
            throw error;
        }
    }

    publishtopublicdatabase() {

    }

    onChange(event = null, prop = null) {
        console.log('onchanc', event, prop);
    }

    onNoClick(): void {
        this.dialogRef.close('test');
    }


    onClose(): void {
        console.log('Dialog is closing');
        this.dialogRef.close();
    }
}
